module.exports = __webpack_public_path__ + "img/asians-group-dark-bfa67db625e34b590484bf102b7d79e3.0530fb30.png";